import { useResponsive } from "./useResponsive";

interface ResponsiveModalConfig {
  /** Modal width - "100%" on mobile, percentage on tablet, fixed on desktop */
  width: number | string;
  /** Whether to center the modal vertically */
  centered: boolean;
}

interface ResponsiveDrawerConfig {
  /** Drawer width - "100%" on mobile, percentage on tablet, fixed on desktop */
  width: number | string;
}

/**
 * Hook to get responsive modal configuration.
 * Returns width and positioning based on current breakpoint.
 *
 * @param desktopWidth - Width for desktop screens (default: 520)
 */
export const useResponsiveModal = (
  desktopWidth: number = 520,
): ResponsiveModalConfig => {
  const { isMobile, isTablet } = useResponsive();

  if (isMobile) {
    return {
      width: "100%",
      centered: false,
    };
  }

  if (isTablet) {
    return {
      width: "90%",
      centered: true,
    };
  }

  return {
    width: desktopWidth,
    centered: true,
  };
};

/**
 * Hook to get responsive drawer configuration.
 * Returns width based on current breakpoint.
 *
 * @param desktopWidth - Width for desktop screens (default: 800)
 */
export const useResponsiveDrawer = (
  desktopWidth: number = 800,
): ResponsiveDrawerConfig => {
  const { isMobile, isTablet } = useResponsive();

  if (isMobile) {
    return { width: "100%" };
  }

  if (isTablet) {
    return { width: "80%" };
  }

  return { width: desktopWidth };
};
